//etilos
import './exportarPlanilla.css'
// import iconExpPlanilla from './IconExpPlanilla.svg'
import { Contacts } from '../../contactos/model'

export const baseUrl = process.env.REACT_APP_API_URL;

export const ExportarPlanilla = ({ filters }) => {

  const exportExcel = async () => {
    await Contacts.getExport(filters)
  }

  return (
    <button className='btn p-btn-light' onClick={exportExcel}>
      <i className="bi bi-file-earmark-excel"></i>
      <span style={{ marginLeft: '5px' }}>Exportar</span>
    </button>
  )
}
